"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServerStore = exports.createNewStore = exports.store = void 0;
/**
 * Generates client and server stores
 */
var redux_1 = require("redux");
var redux_thunk_1 = require("redux-thunk");
var root_reducer_1 = require("./root.reducer");
var composeEnhancer = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : redux_1.compose;
/**
 * Create new Redux store
 *
 * @param initialState
 * @returns {*} store
 */
function createNewStore(initialState) {
    var composer = initialState.config && initialState.config.isProd
        ? redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default))
        : composeEnhancer(redux_1.applyMiddleware(redux_thunk_1.default));
    exports.store = redux_1.createStore(root_reducer_1.default, initialState, composer);
    // let unsubscribe = store.subscribe(() => {
    // 	let state = store.getState();
    // 	if (!state.config.isProd) {
    // 		console.log(require('lodash').omit(state, ['content', 'links', 'fpti']));
    // 	}
    // });
    return exports.store;
}
exports.createNewStore = createNewStore;
/**
 * @function createServerStore - creates a one-off store for use as the model served to the client
 */
function createServerStore(req, res, reducer, state) {
    var store = redux_1.createStore(reducer, state);
    // Subscribe to store to trigger rendering to mimic ReactRedux on client
    store.subscribe(function () {
        var model = store.getState(), entryPoint = "app-view";
        res.render(entryPoint, model);
    });
    return store;
}
exports.createServerStore = createServerStore;
